<script>
import axios from "axios";
import CampaignForm from "@/components/campaignForm";
import Vue from "vue";


/**
 * Form Layouts component
 */
export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  page: {
    title: "Campaign",
  },
  components: {CampaignForm,},
  methods: {
    async saveCampaign(editedCampaign) {
      try {
        this.$store.commit('errorBag/CLEAR');

        const formData = new FormData();
        const fields = ['internal_name', 'public_name', 'image', 'color', 'description', 'start_date', 'end_date',]
        for (let key of fields) {
          if (!editedCampaign[key]) {
            formData.append(key, '');
          } else {
            formData.append(key, editedCampaign[key]);
          }
        }
        this.$store.commit('loader/START_LOADING');

        formData.append('_method', 'PUT');
        const response = await axios.post(`/${this.userType}/campaign/${editedCampaign._id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.$store.commit('campaign/UPDATE_CAMPAIGN', response.data);

        Vue.swal({
          position: "top",
          icon: "success",
          title: "Saved!",
          showConfirmButton: false,
          timer: 1000
        });
      } catch (error) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    }
  },
  computed: {
    userType() {
      return this.$store.getters['user/userType']
    },
  },
};
</script>

<template>
  <div>
    <div class="row pt-3">
      <div class="col-12 offset-xl-2 col-xl-8">

        <h4 class="card-title mb-4 mt-2">Edit Campaign</h4>

        <campaign-form :campaign="campaign" @campaignFormSubmitted="saveCampaign" :is-edit="true"></campaign-form>

      </div>
    </div>
  </div>
</template>
